import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../images/t1_i_one.png';
import _imports_1 from '../images/t1_i_two.png';
import _imports_2 from '../images/line_close_btn.png';
import _imports_3 from '../images/t2_i_one.png';
import _imports_4 from '../images/t2_i_two.png';
import _imports_5 from '../images/t3_i_one.png';
import _imports_6 from '../images/t3_i_two.png';
import _imports_7 from '../images/t5_i_one.png';
import _imports_8 from '../images/t5_i_two.png';
import _imports_9 from '../images/t4_i_one.png';
import _imports_10 from '../images/t4_i_two.png';

var _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"line_title_box_fexd container-fluid long-container\"><div class=\"line_title_box_fiexd container\"><div class=\"line_title_one line_titile_text\">Asset</div><div class=\"line_title_two\"><div class=\"line_titile_text\">Preclinical</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Phase I</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Phase II</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Phase III</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Approval</div></div></div></div>", 1);

var _hoisted_2 = {
  class: "domain_box container"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "domain_title"
}, "Our Pipeline", -1);

var _hoisted_4 = {
  class: "line_np_box col-lg-12 col-md-12 col-sm-12 col-xs-12"
};

var _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"line_title_box\"><div class=\"line_title_one line_titile_text\">Asset</div><div class=\"line_title_two\"><div class=\"line_titile_text\">Preclinical</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Phase I</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Phase II</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Phase III</div><div class=\"line_title\"></div><div class=\"line_titile_text\">Approval</div></div></div>", 1);

var _hoisted_6 = {
  class: "line_c_box_one"
};
var _hoisted_7 = {
  class: "line_c_box_left"
};
var _hoisted_8 = {
  class: "left_box"
};
var _hoisted_9 = {
  class: "line_arrow_box"
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "t1_i_one"
}, null, -1);

var _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "t1_i_two"
}, null, -1);

var _hoisted_12 = [_hoisted_10, _hoisted_11];
var _hoisted_13 = {
  class: "line_right_box"
};
var _hoisted_14 = {
  class: "line_r_t_bbbox"
};
var _hoisted_15 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_16 = ["innerHTML"];
var _hoisted_17 = {
  class: "line_r_t_bbbox"
};
var _hoisted_18 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_19 = ["innerHTML"];
var _hoisted_20 = {
  class: "line_r_t_bbbox"
};
var _hoisted_21 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_22 = ["innerHTML"];
var _hoisted_23 = {
  class: ""
};
var _hoisted_24 = {
  class: "line_text_a"
};
var _hoisted_25 = ["innerHTML"];

var _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_coper"
}, null, -1);

var _hoisted_27 = {
  class: "line_c_box_two"
};
var _hoisted_28 = {
  class: "line_c_box_left"
};
var _hoisted_29 = {
  class: "left_box"
};
var _hoisted_30 = {
  class: "line_arrow_box"
};

var _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "t2_i_one"
}, null, -1);

var _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "t2_i_two"
}, null, -1);

var _hoisted_33 = [_hoisted_31, _hoisted_32];
var _hoisted_34 = {
  class: "line_right_box"
};
var _hoisted_35 = {
  class: "line_r_t_bbbox"
};
var _hoisted_36 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_37 = ["innerHTML"];
var _hoisted_38 = {
  class: "line_r_t_bbbox"
};
var _hoisted_39 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_40 = ["innerHTML"];
var _hoisted_41 = {
  class: ""
};
var _hoisted_42 = {
  class: "line_text_a"
};
var _hoisted_43 = ["innerHTML"];

var _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_coper"
}, null, -1);

var _hoisted_45 = {
  class: "line_c_box_one"
};
var _hoisted_46 = {
  class: "line_c_box_left"
};
var _hoisted_47 = {
  class: "left_box"
};
var _hoisted_48 = {
  class: "line_arrow_box"
};

var _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "t3_i_one"
}, null, -1);

var _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "t3_i_two"
}, null, -1);

var _hoisted_51 = [_hoisted_49, _hoisted_50];
var _hoisted_52 = {
  class: "line_right_box"
};
var _hoisted_53 = {
  class: "line_r_t_bbbox"
};
var _hoisted_54 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_55 = ["innerHTML"];
var _hoisted_56 = {
  class: "line_r_t_bbbox"
};
var _hoisted_57 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_58 = ["innerHTML"];
var _hoisted_59 = {
  class: "line_r_t_bbbox"
};
var _hoisted_60 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_61 = ["innerHTML"];
var _hoisted_62 = {
  class: ""
};
var _hoisted_63 = {
  class: "line_text_a"
};
var _hoisted_64 = ["innerHTML"];

var _hoisted_65 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_coper"
}, null, -1);

var _hoisted_66 = {
  class: "line_c_box_two"
};
var _hoisted_67 = {
  class: "line_c_box_left"
};
var _hoisted_68 = {
  class: "left_box"
};
var _hoisted_69 = {
  class: "line_arrow_box"
};

var _hoisted_70 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "t5_i_one"
}, null, -1);

var _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "t5_i_two"
}, null, -1);

var _hoisted_72 = [_hoisted_70, _hoisted_71];
var _hoisted_73 = {
  class: "line_right_box"
};
var _hoisted_74 = {
  class: "line_r_t_bbbox"
};
var _hoisted_75 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_76 = ["innerHTML"];
var _hoisted_77 = {
  class: "line_r_t_bbbox"
};
var _hoisted_78 = {
  class: "line_r_t_pop_btn_box"
};
var _hoisted_79 = ["innerHTML"];
var _hoisted_80 = {
  class: ""
};
var _hoisted_81 = {
  class: "line_text_a"
};
var _hoisted_82 = ["innerHTML"];

var _hoisted_83 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_coper"
}, null, -1);

var _hoisted_84 = {
  class: "line_c_box_three"
};
var _hoisted_85 = {
  class: "line_c_box_left"
};
var _hoisted_86 = {
  class: "left_box"
};
var _hoisted_87 = {
  class: "line_arrow_box"
};

var _hoisted_88 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "t4_i_one"
}, null, -1);

var _hoisted_89 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "t4_i_two"
}, null, -1);

var _hoisted_90 = [_hoisted_88, _hoisted_89];
var _hoisted_91 = {
  class: "line_right_box"
};
var _hoisted_92 = {
  class: "line_r_t_bbbox"
};
var _hoisted_93 = {
  class: "line_r_t_pop_btn_box"
};

var _hoisted_94 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_r_t_pop_content"
}, null, -1);

var _hoisted_95 = {
  class: "line_r_t_bbbox"
};
var _hoisted_96 = {
  class: "line_r_t_pop_btn_box"
};

var _hoisted_97 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_r_t_pop_content"
}, null, -1);

var _hoisted_98 = {
  class: ""
};
var _hoisted_99 = {
  class: "line_text_a"
};
var _hoisted_100 = ["innerHTML"];

var _hoisted_101 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_b_text line_b_text01"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "xingbiao"
}, "*"), /*#__PURE__*/_createTextVNode("Tenacia has Greater China rights.")], -1);

var _hoisted_102 = /*#__PURE__*/_createElementVNode("div", {
  class: "line_b_text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "xingbiao"
}, "**"), /*#__PURE__*/_createTextVNode("Tenacia has global rights.")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_collapse, {
    accordion: true,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[37] || (_cache[37] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: _normalizeClass(['line_arrow', $setup.activeNames == 1 ? 'rotate' : '']),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $setup.toggleMore(1);
        })
      }, null, 2)]), _createElementVNode("div", {
        class: "line_l_t",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $setup.toggleMore(1);
        })
      }, _hoisted_12)])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box1', $setup.hiddenIndex == 1 ? 'line_r_t_box1_c' : '']),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return $setup.showPop(1);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 1 ? 'line_r_t_t1_s01' : ''])
      }, " CDD ", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 1 ? 'line_r_t_t1_s01' : ''])
      }, " CDKL5 Deficiency Disorder ", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 1 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[3] || (_cache[3] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[0].content : ''
      }, null, 8, _hoisted_16)])], 2)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box2', $setup.hiddenIndex == 2 ? 'line_r_t_box2_c' : '']),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return $setup.showPop(2);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 2 ? 'line_r_t_t1_s01' : ''])
      }, " TSC ", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 2 ? 'line_r_t_t1_s01' : ''])
      }, " Tuberous Sclerosis Complex ", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 2 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[5] || (_cache[5] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[1].content : ''
      }, null, 8, _hoisted_19)])], 2)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box2', $setup.hiddenIndex == 3 ? 'line_r_t_box2_c' : '']),
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return $setup.showPop(3);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 3 ? 'line_r_t_t1_s01' : ''])
      }, " SE ", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 3 ? 'line_r_t_t1_s01' : ''])
      }, " Status Epilepticus ", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 3 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[7] || (_cache[7] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[2].content : ''
      }, null, 8, _hoisted_22)])], 2)])])]), _createVNode(_component_el_collapse_item, {
        class: "Consistency",
        name: 1
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
            src: _imports_2,
            class: "line_close_btn",
            onClick: _cache[8] || (_cache[8] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          }), _createElementVNode("div", {
            class: "line_text_content",
            innerHTML: $setup.articleList.length > 0 ? $setup.articleList[0].content : ''
          }, null, 8, _hoisted_25)]), _hoisted_26])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
        class: _normalizeClass(['line_arrow2', $setup.activeNames == 2 ? 'rotate2' : '']),
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return $setup.toggleMore(2);
        })
      }, null, 2)]), _createElementVNode("div", {
        class: "line_l_t",
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return $setup.toggleMore(2);
        })
      }, _hoisted_33)])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box3', $setup.hiddenIndex == 4 ? 'line_r_t_box3_c' : '']),
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return $setup.showPop(4);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 4 ? 'line_r_t_t1_s02' : ''])
      }, "ET", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 4 ? 'line_r_t_t1_s02' : ''])
      }, "Essential Tremor", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 4 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[12] || (_cache[12] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[3].content : ''
      }, null, 8, _hoisted_37)])], 2)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box4', $setup.hiddenIndex == 5 ? 'line_r_t_box4_c' : '']),
        onClick: _cache[13] || (_cache[13] = function ($event) {
          return $setup.showPop(5);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 5 ? 'line_r_t_t1_s02' : ''])
      }, "PD", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 5 ? 'line_r_t_t1_s02' : ''])
      }, "Parkinson's Disease", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 5 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[14] || (_cache[14] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[4].content : ''
      }, null, 8, _hoisted_40)])], 2)])])]), _createVNode(_component_el_collapse_item, {
        class: "Consistency",
        name: 2
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("img", {
            src: _imports_2,
            class: "line_close_btn",
            onClick: _cache[15] || (_cache[15] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          }), _createElementVNode("div", {
            class: "line_text_content",
            innerHTML: $setup.articleList.length > 0 ? $setup.articleList[1].content : ''
          }, null, 8, _hoisted_43)]), _hoisted_44])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
        class: _normalizeClass(['line_arrow3', $setup.activeNames == 3 ? 'rotate3' : '']),
        onClick: _cache[16] || (_cache[16] = function ($event) {
          return $setup.toggleMore(3);
        })
      }, null, 2)]), _createElementVNode("div", {
        class: "line_l_t",
        onClick: _cache[17] || (_cache[17] = function ($event) {
          return $setup.toggleMore(3);
        })
      }, _hoisted_51)])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", {
        class: _normalizeClass(['new_line_r_t_box5', $setup.hiddenIndex == 6 ? 'new_line_r_t_box5_c' : '']),
        onClick: _cache[18] || (_cache[18] = function ($event) {
          return $setup.showPop(6);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 6 ? 'line_r_t_t1_s03' : ''])
      }, "CIDP", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 6 ? 'line_r_t_t1_s03' : ''])
      }, " Chronic Inflammatory Demyelinating Polyneuropathy ", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 6 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[19] || (_cache[19] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[5].content : ''
      }, null, 8, _hoisted_55)])], 2)]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box5', $setup.hiddenIndex == 7 ? 'line_r_t_box5_c' : '']),
        onClick: _cache[21] || (_cache[21] = function ($event) {
          return $setup.showPop(7);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 7 ? 'line_r_t_t1_s03' : ''])
      }, "gMG", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 7 ? 'line_r_t_t1_s03' : ''])
      }, "Generalized Myasthenia Gravis", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 7 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_57, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[20] || (_cache[20] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[6].content : ''
      }, null, 8, _hoisted_58)])], 2)], 2)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box5', $setup.hiddenIndex == 8 ? 'line_r_t_box5_c' : '']),
        onClick: _cache[23] || (_cache[23] = function ($event) {
          return $setup.showPop(8);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 8 ? 'line_r_t_t1_s03' : ''])
      }, "MMN", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 8 ? 'line_r_t_t1_s03' : ''])
      }, "Multifocal Motor Neuropathy", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 8 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_60, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[22] || (_cache[22] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[7].content : ''
      }, null, 8, _hoisted_61)])], 2)], 2)])])]), _createVNode(_component_el_collapse_item, {
        class: "Consistency",
        name: 3
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("img", {
            src: _imports_2,
            class: "line_close_btn",
            onClick: _cache[24] || (_cache[24] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          }), _createElementVNode("div", {
            class: "line_text_content",
            innerHTML: $setup.articleList.length > 0 ? $setup.articleList[2].content : ''
          }, null, 8, _hoisted_64)]), _hoisted_65])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", {
        class: _normalizeClass(['line_arrow3', $setup.activeNames == 4 ? 'rotate3' : '']),
        onClick: _cache[25] || (_cache[25] = function ($event) {
          return $setup.toggleMore(4);
        })
      }, null, 2)]), _createElementVNode("div", {
        class: "line_l_t",
        onClick: _cache[26] || (_cache[26] = function ($event) {
          return $setup.toggleMore(4);
        })
      }, _hoisted_72)])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", {
        class: _normalizeClass(['new_line_r_t_box8', $setup.hiddenIndex == 11 ? 'new_line_r_t_box8_c' : '']),
        onClick: _cache[27] || (_cache[27] = function ($event) {
          return $setup.showPop(11);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 11 ? 'line_r_t_t1_s03' : ''])
      }, "FOS", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 11 ? 'line_r_t_t1_s03' : ''])
      }, " Focal Onset Seizures ", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 11 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_75, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[28] || (_cache[28] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[8].content : ''
      }, null, 8, _hoisted_76)])], 2)]), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box9', $setup.hiddenIndex == 12 ? 'line_r_t_box9_c' : '']),
        onClick: _cache[30] || (_cache[30] = function ($event) {
          return $setup.showPop(12);
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 12 ? 'line_r_t_t1_s03' : ''])
      }, "BD-mania", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 12 ? 'line_r_t_t1_s03' : ''])
      }, "Bipolar Mania ", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 12 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_78, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[29] || (_cache[29] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _createElementVNode("div", {
        class: "line_r_t_pop_content",
        innerHTML: $setup.fieldList.length > 0 ? $setup.fieldList[9].content : ''
      }, null, 8, _hoisted_79)])], 2)], 2)])])]), _createVNode(_component_el_collapse_item, {
        class: "Consistency",
        name: 4
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("img", {
            src: _imports_2,
            class: "line_close_btn",
            onClick: _cache[31] || (_cache[31] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          }), _createElementVNode("div", {
            class: "line_text_content",
            innerHTML: $setup.articleList.length > 0 ? $setup.articleList[3].content : ''
          }, null, 8, _hoisted_82)]), _hoisted_83])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createElementVNode("div", {
        class: _normalizeClass(['line_arrow4', $setup.activeNames == 5 ? 'rotate4' : '']),
        onClick: _cache[32] || (_cache[32] = function ($event) {
          return $setup.toggleMore(5);
        })
      }, null, 2)]), _createElementVNode("div", {
        class: "line_l_t",
        onClick: _cache[33] || (_cache[33] = function ($event) {
          return $setup.toggleMore(5);
        })
      }, _hoisted_90)])]), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box6', $setup.hiddenIndex == 9 ? 'line_r_t_box6_c' : ''])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t1', $setup.hiddenIndex == 9 ? 'line_r_t_t1_s04' : ''])
      }, "SUD", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 9 ? 'line_r_t_t1_s04' : ''])
      }, "Substance Use Disorder", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 9 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_93, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[34] || (_cache[34] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _hoisted_94])], 2)]), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_box7', $setup.hiddenIndex == 10 ? 'line_r_t_box7_c' : ''])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 10 ? 'line_r_t_t1_s04' : ''])
      }, "More indications", 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_t2', $setup.hiddenIndex == 10 ? 'line_r_t_t1_s04' : ''])
      }, "under exploration", 2)], 2), _createElementVNode("div", {
        class: _normalizeClass(['line_r_t_pop', $setup.hiddenIndex == 10 ? 'line_r_t_pop_show' : ''])
      }, [_createElementVNode("div", _hoisted_96, [_createElementVNode("img", {
        src: _imports_2,
        class: "pop_close_btn",
        onClick: _cache[35] || (_cache[35] = _withModifiers(function () {
          return $setup.closePop && $setup.closePop.apply($setup, arguments);
        }, ["stop"]))
      }), _hoisted_97])], 2)])])]), _createVNode(_component_el_collapse_item, {
        class: "Consistency",
        name: 5
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_createElementVNode("img", {
            src: _imports_2,
            class: "line_close_btn",
            onClick: _cache[36] || (_cache[36] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          }), _createElementVNode("div", {
            class: "line_text_content",
            innerHTML: $setup.articleList.length > 0 ? $setup.articleList[4].content : ''
          }, null, 8, _hoisted_100)])])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"]), _hoisted_101, _hoisted_102])])], 64);
}